/**
 * AUTODOC 평가 모듈 - 공통 상수 및 유틸
 */

// API 베이스 URL (AUTODOC 기존 Express 서버)
// Phase 2: REACT_APP_API_BASE 우선, 빈 값이면 기존 동작 (window.location.origin / localhost)
var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
var _runtimeBase = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:4000';
export var API_BASE = _envBase || _runtimeBase;

// 오더 상태 설정
export const ORDER_STATUS = {
  open:       { label: '콜 대기',   color: '#3B8BD4', bg: '#E6F1FB' },
  taken:      { label: '콜 수락',   color: '#1D9E75', bg: '#E1F5EE' },
  inspecting: { label: '검차중',    color: '#BA7517', bg: '#FAEEDA' },
  completed:  { label: '검차완료',  color: '#534AB7', bg: '#EEEDFE' },
  decided:    { label: '매입완료',  color: '#D85A30', bg: '#FAECE7' },
  rejected:   { label: '매입불가',  color: '#A32D2D', bg: '#FCEBEB' },
  cancelled:  { label: '취소',      color: '#888780', bg: '#F1EFE8' },
};

// 평가사 등급
export const INSPECTOR_LEVELS = {
  '마스터': { color: '#D85A30', bg: '#FAECE7', feeRate: 1.2, desc: '100건+ & 평점 4.5+' },
  '시니어': { color: '#534AB7', bg: '#EEEDFE', feeRate: 1.1, desc: '50건+ & 평점 4.0+' },
  '일반':   { color: '#888780', bg: '#F1EFE8', feeRate: 1.0, desc: '기본' },
};

// 도막 수치 → 색상
export function getPaintColor(value) {
  if (!value) return '#B4B2A9';
  if (value < 150) return '#1D9E75';  // 정상
  if (value < 250) return '#EF9F27';  // 도장
  return '#E24B4A';                    // 판금/용접
}

// 도막 수치 → 상태 텍스트
export function getPaintStatus(value) {
  if (!value) return '-';
  if (value < 150) return '정상';
  if (value < 250) return '도장';
  return '판금';
}

// 날짜 포맷
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

// 금액 포맷
export function formatMoney(amount) {
  if (!amount) return '-';
  return Number(amount).toLocaleString() + '원';
}

// API 호출 헬퍼
export async function api(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const config = {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  };
  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }
  const res = await fetch(url, config);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || '요청 실패');
  return data;
}
